const Main = () =>
    import ('@/views/main');
const memberUser = () =>
    import ('@/views/member/memberUser');
const repairOrder = () =>
    import ('@/views/member/repairOrder');
const repairCard = () =>
    import ('@/views/member/repairCard');
const vipDetail = () =>
    import ('@/views/member/vipDetail');
const storeDetail = () =>
    import ('@/views/member/storeDetail');
const orderRecord = () =>
    import ('@/views/member/orderRecord');
const useDetailMember = () =>
    import ('@/views/order/usingDetail');
const batchManage = () =>
    import ('@/views/member/batchManage');
const failDetail = () =>
    import ('@/views/member/fail-detail');
const storedVlaueUseRecored = () =>
    import ('@/views/member/stored-value-use-recored');
const repairCardList = () =>
    import ('@/views/member/repair-card-list');
const memberOperationRecord = () =>
    import ('@/views/member/operation-record');

const userTicket = () => import('@/views/order/user-ticket');
const usingDetail = () => import('@/views/order/usingDetail');
const operateRecord = () => import('@/views/order/operate-record');
const amendTicket = () => import('@/views/order/amendTicket');
const giveTicket = () => import('@/views/order/give-ticket');
const userCoupon = () => import('@/views/member/user-coupon');

export default [{
    path: '/member',
    name: 'member',
    component: Main,
	redirect: {
		name: 'memberUser'
	},
    meta: {
        hide: false,
        name: '会员管理',
        unfold: true,
        iconType: "1"
    },
    children: [{
            path: 'memberUser',
            name: 'memberUser',
            component: memberUser,
            meta: {
                name: '会员用户管理'
            },
            children: [{
                    path: "vipDetail/:id",
                    component: vipDetail,
                    name: "vipDetail",
                    meta: {
                        name: '会员详情'
                    },
                    children: [
                        {
                            path: "storedVlaueUseRecored",
                            component: storedVlaueUseRecored,
                            name: "storedVlaueUseRecored",
                            meta: {
                                name: '储值余额消费记录'
                            },
                        }
                    ]
                },
                {
                    path: "storeDetail",
                    component: storeDetail,
                    name: "storeDetail",
                    meta: {
                        name: '积分详情'
                    },
                },
                {
                    path: "orderRecord",
                    component: orderRecord,
                    name: "orderRecord",
                    meta: {
                        name: '购买订单记录'
                    },
                },
                {
                    path: "memberOperationRecord",
                    component: memberOperationRecord,
                    name: "memberOperationRecord",
                    meta: {
                        name: '操作记录'
                    },
                },
            ]
        },
        {
            path: "/userTicket",
            name: "userTicket",
            component: userTicket,
            meta: {
                name: "用户票券管理"
            },
            children: [
                {
                    path: "usingDetailUser",
                    component: usingDetail,
                    name: "usingDetailUser",
                    meta: {
                        name: '使用详情'
                    },
                },
                {
                    path: "operateRecord",
                    component: operateRecord,
                    name: "operateRecord",
                    meta: {
                        name: '操作记录'
                    },
                },
                {
                    path: "amendTicketUser",
                    component: amendTicket,
                    name: "amendTicketUser",
                    meta: {
                        name: '票券信息修改'
                    },
                },
                {
                    path: "giveTicket",
                    component: giveTicket,
                    name: "giveTicket",
                    meta: {
                        name: '赠送票详情'
                    },
                },
            ]
        },
        {
            path: "/userCoupon",
            name: "userCoupon",
            component: userCoupon,
            meta: {
                name: "用户优惠券管理"
            },
        },
        {
            path: 'repairOrder',
            name: 'repairOrder',
            component: repairOrder,
            meta: {
                name: '补预约'
            },
        },
        {
            path: 'repairCard',
            name: 'repairCard',
            component: repairCard,
            meta: {
                name: '补开卡'
            },
            children: [
                {
                    path: "batchManage",
                    component: batchManage,
                    name: "batchManage",
                    meta: {
                        name: '批量导入管理'
                    },
                    children: [
                        {
                            path: 'failDetail',
                            name: 'failDetail',
                            component: failDetail,
                            meta: {
                                name: '失败数据查看'
                            },
                        }
                    ]
                },
                {
                    path: "repairCardList",
                    component: repairCardList,
                    name: "repairCardList",
                    meta: {
                        name: '手动补开卡信息管理'
                    },
                }
            ]
        },
    ]
}]